export default __webpack_public_path__ + "static/media/13.c2a093f8.svg";